import { useIntl } from 'react-intl';
import { formatCurrency } from 'utils';

import { TableColumn } from '../..';

import { PaymentSessionsTableProps } from './types';

import * as S from '../styles';

const PaymentSessionsTable: React.FC<PaymentSessionsTableProps> = ({
  data,
  isLoading,
  currencyCode,
  sessionsTotal,
  sessionsAmount,
  isClosedInvoice,
}) => {
  const intl = useIntl();

  const sessionsData = [
    ...(data || []),
    {
      baseValue: null,
      status: 'subtotal',
      amount: sessionsAmount,
      finalValue: sessionsTotal || null,
    },
  ];

  const mapStatusToSuffixTranslationKey = (status: string) => {
    const translationMap = {
      completed: 'CPPLATFORM.SESSIONSTATUS.COMPLETED',
      eu_no_show: 'CPPLATFORM.SESSIONSTATUS.USERNOSHOW',
      initial_session: 'CPPLATFORM.SESSIONSTATUS.WELCOMES',
      subtotal: 'CPPAYMENTS.TEXT.SUBTOTAL',
    };

    return translationMap[status as keyof typeof translationMap] || status;
  };

  const columns: TableColumn[] = [
    {
      key: 'transaction_status',
      dataKey: 'status',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.STATUS' }),
      render: (status: string) =>
        intl.formatMessage({
          id: mapStatusToSuffixTranslationKey(status),
        }),
    },
    {
      key: 'transaction_amount',
      dataKey: 'amount',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.AMOUNT' }),
      render: amount =>
        typeof amount === 'number' && isClosedInvoice ? amount : '-',
    },
    {
      key: 'transaction_base_value',
      dataKey: 'baseValue',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.BASEVALUE' }),
      render: (baseValue: number | null) =>
        typeof baseValue === 'number' && isClosedInvoice
          ? formatCurrency(baseValue, currencyCode)
          : '-',
    },
    {
      key: 'transaction_final_value',
      dataKey: 'finalValue',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.VALUE' }),
      render: (finalValue: number | null) =>
        typeof finalValue === 'number' && isClosedInvoice
          ? formatCurrency(finalValue, currencyCode)
          : '-',
    },
  ];

  return (
    <S.Container data-testid="invoice-sessions-table-container">
      <S.StyledTable
        loadingLines={4}
        columns={columns}
        loading={isLoading}
        data={sessionsData}
        loadingStyle="LinesMedium"
        isClosedInvoice={isClosedInvoice}
      />
    </S.Container>
  );
};

export default PaymentSessionsTable;
